<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="accommodationInfo container">
    <h2 v-text="data.title" />
    <div class="accommodationInfo__Grid" :class="[`grid-${numberOfSections}`]">
      <div class="accommodationInfo__Location accommodationInfo__GridItem">
        <h3 v-text="$t('locationTitle')" />
        <p>
          <Icon name="location" />
          {{ page?.address }}
        </p>

        <Button type="nuxt-link" :to="`https://www.google.com/maps?q=${page?.latitude},${page?.longitude}`" external medium secondary>
          {{ $t('mapView') }}
        </Button>
      </div>

      <div v-if="amenitiesList.length" class="accommodationInfo__Amenities accommodationInfo__GridItem" :class="{'allAmenities': amenitiesList.length === data.amenities?.amenities?.items.length}">
        <h3 v-text="data.amenities.title" />
        <div class="accommodationInfo__AmenitiesList">
          <ul>
            <li v-for="item in amenitiesList">
              <Flare :src="item.image" width="24" height="24" size="both" crop="fill" gravity="faces" :alt="item.image" />
              <template v-if="item.description">{{ item.description }}</template>
            </li>
          </ul>
        </div>
        <Button v-if="data.amenities?.amenities?.items.length > amenitiesOffset && amenitiesList.length < data.amenities?.amenities?.items.length" medium secondary @click="toggleAmenitiesList">{{ $t('allAmenities') }}</Button>
      </div>

      <div v-if="data.meal_plan_title && accommodation" class="accommodationInfo__MealPlans accommodationInfo__GridItem">
        <h3 v-text="data.meal_plan_title" />
        <ul>
          <li v-for="item in accommodation.accommodation_meal_plans">
            {{ item.name }}
            <Tooltip v-if="item.description" :text="item.description">
              <template #icon>
                <Icon name="information" />
              </template>
            </Tooltip>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });
  const { accommodationsData } = useSetup();
  const { page } = usePage();
  const amenitiesList = ref([]);
  const amenitiesOffset = 5;

  const numberOfSections = computed(() => {
    let counter = 1;
    if (props.data.amenities?.amenities?.items?.length) counter++;
    if (props.data.meal_plan_title) counter++;
    return counter;
  });

  const accommodation = computed(() => accommodationsData.value[page.value.id]);

  onMounted(() => {
    if (props.data.amenities?.amenities?.items?.length) {
      amenitiesList.value = props.data.amenities.amenities.items.slice(0, amenitiesOffset);
    }
  });

  function toggleAmenitiesList() {
    amenitiesList.value = props.data.amenities.amenities.items;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_accommodationInfo.scss');
</style>